import { render } from "./PROPOSAL_UPDATED_MINOR.vue?vue&type=template&id=49b7744c"
import script from "./PROPOSAL_UPDATED_MINOR.vue?vue&type=script&lang=js"
export * from "./PROPOSAL_UPDATED_MINOR.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__